import { useState, useEffect } from 'react';

export function useChatWindow(focusInput) {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  useEffect(() => {
    if (!isOpen) return;
    const timer = setTimeout(() => focusInput?.(), 280);
    return () => clearTimeout(timer);
  }, [isOpen, focusInput]);

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen]);

  return { isOpen, open, close };
}
